import HtmlElement from './HtmlElement';
import {Settings} from '../Settings';
import {$window, $body} from '../Constants';
import HorizontalSubMenu from "./HorizontalSubMenu";

/**
 * Javascript Wrapper for the Header HTMLElement
 */
class Header extends HtmlElement {

    constructor($element) {
        super($element);

        this.transitionEnabled = false;
        this.metaBarHideOnScrolled = true;
        this.isScrolled = false;

        this.$metaBar = this.$element.find('.meta-bar');
        this.metaBarHeight = this.$metaBar.outerHeight();
    }

    onReady() {
        this.toggleScrolled();
    }

    onResize() {
        this.toggleScrolled();
    }

    onLoad() {
        this.enableTransition();
    }

    onScroll() {
        this.toggleScrolled();
    }

    /**
     * Toggle the headers "scrolled" state
     */
    toggleScrolled() {
        if($window.width() > Settings.headerScrollToggleMinWidth && Settings.headerScrolledAt > 0) {
            // add scrolled class when below headerScrolledAt value or remove when above
            if(!this.isScrolled) {
				if($window.scrollTop() >= Settings.headerScrolledAt) {
				    this.$element.addClass(Settings.classScrolled);

				    if(this.metaBarHideOnScrolled) {
						this.$element.css('transform', 'translate3d(0, -' + this.metaBarHeight + 'px, 0)');
                    }

                    this.isScrolled = true;

				    if(HorizontalSubMenu.exists()) {
						HorizontalSubMenu.updateScrolledAt();
						HorizontalSubMenu.adjustTopValue();
					}
				}
            }else {
				if($window.scrollTop() < Settings.headerScrolledAt) {
					this.$element.removeClass(Settings.classScrolled);

					if(this.metaBarHideOnScrolled) {
						this.$element.css('transform', 'translate3d(0, 0, 0)');
					}

                    this.isScrolled = false;

					if(HorizontalSubMenu.exists()) {
						HorizontalSubMenu.updateScrolledAt();
						HorizontalSubMenu.adjustTopValue();
					}
				}
            }
        }
    }

    /**
     * Enable Transitions on the Header
     */
    enableTransition() {
        if(!this.transitionEnabled) {
            this.$element.addClass(Settings.classTransitionEnabled);
        }
    }
}

export default (new Header($body.find('header#header')));